import DisclosureLogEntryService from '@/services/bytepro/disclosureLogEntry.service';

export const disclosureLogEntry = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    get({ commit }, fileDataId){
      return DisclosureLogEntryService.get(fileDataId).then(
        resp => {
          commit('dummy', "get - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "get - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    }
  }
};